/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { logNormal, logInformation, logWarning, logError, logDebug, logConsole, logRawTrack, logTransports, logAutomationError } from "./bootstrap_web_ext";
import {JSONManager , globalEngine, ModuleManager} from "./Init";

// #ENDIF WebPack
function getEventTransportProfiles()

    {
        var profiles = 
        {
            "getProfiles": function()
            {
                if (this.__allProfiles) 
                {
                    return this._allProfiles;
                }

                try
                {
                    this._allProfiles = JSONManager.create("profile");
                }
                catch (e)
                {
                    logError("ERROR: Could not load profile.json " + e.message);
                }
                return this._allProfiles;
            },
            "_allProfiles": {}
        };

        return profiles.getProfiles();
    }


ModuleManager.registerFactory("transport_config", getEventTransportProfiles);
//export  {getEventTransportProfiles};
//globalEngine.FactoryMap["transport_config"] = getEventTransportProfiles;
